<template>
  <v-flex xs12>
    <div class="section-title di-flex justify-space-between">
      Lab Tests
      <v-tooltip top>
        <v-btn
          slot="activator"
          small
          color="secondary"
          icon
          @click="dialog = true;"
          class="ma-0 shadow"
        >
          <v-icon small>mdi-plus</v-icon>
        </v-btn>

        <span>Add Test</span>
      </v-tooltip>
    </div>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card class="px-3">
          <v-card-title primary-title class="title">New Lab Test</v-card-title>
          <v-card-text class="pa-0">
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field disabled label="Patient" v-model="patient.name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :items="testsList"
                    v-model="newTest.tests"
                    label="Select tests "
                    item-value="id"
                    item-text="name"
                    multiple
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 class="text-xs-right mt-3">
                  <v-btn flat @click="clean">Close</v-btn>

                  <v-btn class="mx-0" :loading="loading" color="primary" @click="submit">Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-dialog v-model="currentResultDialog" max-width="900">
      <v-card>
        <v-card-text>
          <div v-html="currentResult" v-if="currentResult"></div>
          <div v-else>No Result Yet.</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table disable-initial-sort :headers="headers" :items="patient.tests">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.date | moment('YYYY-MM-DD h:mm:ss A') }}</td>
            <td>
              <v-btn
                v-if="props.item.result"
                class="mx-0"
                small
                @click="currentResult = props.item.result; currentResultDialog = true;"
              >view result</v-btn>

              <span v-else>No Result Yet</span>
            </td>
            <td class="text-capitalize">{{ props.item.doctor.name }}</td>
            <td class="text-capitalize" :class="props.item.status">{{ props.item.status }}</td>
            <td>
              <v-tooltip top v-if="props.item.status === 'pending'">
                <v-icon @click="deleteTest(props.item)" slot="activator">mdi-delete-outline</v-icon>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentResultDialog: false,
      currentResult: "",
      headers: [
        { text: "Test Name", value: "name" },
        { text: "Date", value: "date" },
        { text: "Result", value: "result" },
        { text: "Doctor", value: "doctor.id" },
        { text: "Status", value: "status" },
        { text: "", value: "id" }
      ],
      loading: false,
      dialog: false,
      newTest: {
        tests: []
      }
    };
  },
  methods: {
    showTestDetails(test) {},
    deleteTest(test) {
      this.$modal.show({
        mode: "delete",
        message: `Are you sure you want to delete this Lab Test? ${test.name}`,
        onConfirm: () => {
          this.axios
            .delete(`/api/patients/${this.patient.id}/tests/${test.id}`)
            .then(() => this.$emit("refresh"))
            .finally(resp => {
              this.clean();
            });
        }
      });
    },
    submit() {
      if (this.newTest.tests.length > 0) {
        this.loading = true;
        this.axios
          .post(`/api/patients/${this.patient.id}/tests`, this.newTest)
          .then(resp => {
            this.$emit("refresh");
          })
          .finally(() => this.clean());
      }
    },
    clean() {
      this.newTest.tests = [];
      this.dialog = false;
      this.loading = false;
    }
  },
  computed: {
    testsList() {
      return this.$store.getters["base/tests"];
    }
  },
  mounted() {
    this.$store.dispatch("base/loadTests");
  }
};
</script>